//// login-view.js
// dashboard-view.js

import $ from 'jquery';
import _ from 'lodash';

import { View } from 'backbone';
import NotificationService from 'NotificationService.js';
import util from 'util/Util';

import contentTemplate from 'forgot-password-view.ejs';
import RestService from 'RestService.js';

class ForgotPasswordView extends View {
//
    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.events = {
            'click #mainCaptcha': 'setCaptcha',
            'click #resetPasswordSubmit': 'resetPassword',
            'click #backToLogin': 'backToLogin',
            'keyup #mainCaptcha2,#emailResetPassword':'validateCaptcha'
        };
        this.model.set('code', '');
        this.model.set('email', '');

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    validateCaptcha(ev){
        let stringCaptcha = $('#mainCaptcha').text().split(' ').join('');
        let stringCaptchaInput = $('#mainCaptcha2').val().split(' ').join('');
        let stringEmail = $('#emailResetPassword').val().split(' ').join('');

        if (stringCaptcha.toLowerCase() !== stringCaptchaInput.toLowerCase() ||
            stringCaptchaInput === "" ||
            (stringEmail === "" || ! util.validateEmail(stringEmail)) ) {
            $('#resetPasswordSubmit').prop('disabled',true);
        }
        else{
            $('#resetPasswordSubmit').prop('disabled',false);
        }
    }

    resetPassword(evt){
        let stringEmail=$('#emailResetPassword').val();
        RestService.sendForgottenPassword(stringEmail).then((result)=>{
            $("#mainCaptcha2").prop('disabled',true);
            $("#emailResetPassword").prop('disabled',true);
            $("#resetPasswordSubmit").prop('disabled',true);
            $("#instructions").hide();
            $("#successMessage").show();
        }).catch((error) => {
            console.log(error);
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    backToLogin(){
        Backbone.history.loadUrl('login');
    }

    setCaptcha(){
        //// Assign some temp variable of the Captcha Id.
        let code;

        // Increase the length of characters here.
        let alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0');
        // If the source is local, create the captcha in browser.
        // Else get it from a .PHP or NodeJS file
            let i;
            for (i = 0; i < 6; i++) {
                var a = alpha[Math.floor(Math.random() * alpha.length)];
                var b = alpha[Math.floor(Math.random() * alpha.length)];
                var c = alpha[Math.floor(Math.random() * alpha.length)];
                var d = alpha[Math.floor(Math.random() * alpha.length)];
                var e = alpha[Math.floor(Math.random() * alpha.length)];
                var f = alpha[Math.floor(Math.random() * alpha.length)];
                var g = alpha[Math.floor(Math.random() * alpha.length)];
            }
            code = a + ' ' + b + ' ' + ' ' + c + ' ' + d + ' ' + e + ' ' + f + ' ' + g;

            // Attach to DOM
        $('#mainCaptcha').text(code);

        // Set Colors of code
        let colors = ["#B40404", "#beb1dd", "#b200ff", "#faff00", "#0000FF", "#FE2E9A", "#FF0080", "#2EFE2E"];
        let rand = Math.floor(Math.random() * colors.length);
        $('#mainCaptcha').css('color',colors[rand]);
    }



    render() {
        $(this.el).html(this.template(this.model.toJSON()));
        $(this.el).parent().addClass('blue-background');
        this.setCaptcha();
        $("#instructions").show();
        $("#successMessage").hide();

        this.delegateEvents();
        return this;
    }
}

export default ForgotPasswordView;
